import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { LoginDropdown } from './LoginDropdown';

export const LoginButton = ({ className, children, id, isOpen: controlledOpen, onToggle }) => {
  const { currentUser } = useAuth();
  const [internalOpen, setInternalOpen] = useState(false);
  const isOpen = controlledOpen !== undefined ? controlledOpen : internalOpen;
  const setIsOpen = onToggle || setInternalOpen;

  const label = currentUser ? currentUser.displayName?.split(' ')[0] || 'Account' : children;

  return (
    <div className="login-button-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
      <button className={className} onClick={() => setIsOpen(!isOpen)} id={id}>
        {label}
      </button>
      <LoginDropdown isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};
